import * as XLSX from "xlsx";

const reportJson = {
  "Anemia Studies": {
    advanced: {
      about: {
        header: {
          en: "About Anemia",
          ar: "حول فقر الدم",
          hi: "एनीमिया के बारे में",
        },
        text: {
          en: "Anemia is the condition where your body has less Red Blood Cells (RBCs) or RBCs do not have enough hemoglobin. Hemoglobin is an oxygen binding protein inside RBC. RBCs carry oxygen to different parts of your body. Anemia, if left untreated for a prolonged period of time, can lead to cardiovascular diseases and multiorgan failure.",
          ar: "فقر الدم هو الحالة التي يحتوي فيها جسمك على عدد أقل من كريات الدم الحمراء (خلايا الدم الحمراء) أو أن كريات الدم الحمراء لا تحتوي على ما يكفي من الهيموجلوبين. الهيموجلوبين هو البروتين الموجود في كريات الدم الحمراء التي تساعد في نقل الأكسجين إلى أنسجة الجسم.",
          hi: "एनीमिया वह स्थिति है जहां आपके शरीर में आरबीसी (लाल रक्त कोशिकाएं) कम होती हैं या आरबीसी में पर्याप्त हीमोग्लोबिन नहीं होता है। हीमोग्लोबिन आरबीसी में मौजूद प्रोटीन है जो आपके शरीर के सभी अंगो में ऑक्सीजन ले जाने में मदद करता है।",
        },
      },
      tips: [
        {
          header: {
            en: "Overall Diet and Lifestyle to avoid Anemia",
            ar: "",
            hi: "",
          },
          tipsArray: [
            {
              text: {
                en: "If you are a strict vegetarian then you might be vitaminB12 deficient. This vitamin is naturally present in meat, fish, egg and dairy products. You can try cereals fortified with B12, mushrooms and B12 supplements.",
                ar: "",
                hi: "",
              },
              svg: "cheese-color.svg",
            },
            {
              text: {
                en: "Eat a balanced diet that is rich in iron. Common iron rich foods are chana saag, spinach, kaante wali chaulai, onion stalks, mustard leaves, methi, mint, arvi ka saag, bengal gram whole, arhar daal, unripe banana, urad bean, soybean, wheat, jowar, bajra, sprouted pulses, lentils, watermelon, seetaphal, sesame, jaggery, dried fruits, egg, fish, mutton. ",
                ar: "",
                hi: "",
              },
              svg: "spinach_colored.svg",
            },
            {
              text: {
                en: "Maintain a healthy weight as any fluctuations from the ideal weight may result in changes in absorption and metabolism of B complex vitamins and thus lead to folate or VitB12 deficiency anemia.",
                ar: "",
                hi: "",
              },
              svg: "Exercise-single.svg",
            },
            {
              text: {
                en: "Take vitamin A rich foods like red and yellow fruits (papaya, muskmelon, mango), fortified milk and oils, fish liver oil, peas, ragi etc., as this vitamin may increase iron absorption from food.",
                ar: "",
                hi: "",
              },
              svg: "Food-icon.svg",
            },
          ],
        },
      ],
    },
    dynamic: {
      about: {
        header: {
          en: "About Anemia",
          ar: "حول فقر الدم",
          hi: "एनीमिया के बारे में",
        },
        text: {
          en: "Anemia is the condition where your body has less Red Blood Cells (RBCs) or RBCs do not have enough hemoglobin. Hemoglobin is an oxygen binding protein inside RBC. RBCs carry oxygen to different parts of your body. Anemia, if left untreated for a prolonged period of time, can lead to cardiovascular diseases and multiorgan failure.",
          ar: "فقر الدم هو الحالة التي يحتوي فيها جسمك على عدد أقل من كريات الدم الحمراء (خلايا الدم الحمراء) أو أن كريات الدم الحمراء لا تحتوي على ما يكفي من الهيموجلوبين. الهيموجلوبين هو البروتين الموجود في كريات الدم الحمراء التي تساعد في نقل الأكسجين إلى أنسجة الجسم.",
          hi: "एनीमिया वह स्थिति है जहां आपके शरीर में आरबीसी (लाल रक्त कोशिकाएं) कम होती हैं या आरबीसी में पर्याप्त हीमोग्लोबिन नहीं होता है। हीमोग्लोबिन आरबीसी में मौजूद प्रोटीन है जो आपके शरीर के सभी अंगो में ऑक्सीजन ले जाने में मदद करता है।",
        },
      },
      tips: [
        {
          header: { en: "Diet Tips to avoid Anemia", ar: "", hi: "" },
          tipsArray: [
            {
              text: {
                en: "Eat a balanced diet that is rich in iron. Common iron rich foods are chana saag, spinach, kaante wali chaulai, onion stalks, mustard leaves, methi, mint, arvi ka saag, bengal gram whole, arhar daal, unripe banana, urad bean, soybean, wheat, jowar, bajra, sprouted pulses, lentils, watermelon, seetaphal, sesame, jaggery, dried fruits, egg, fish, mutton.",
                ar: "",
                hi: "",
              },
              svg: "spinach-multi-color-icon.png",
            },
            {
              text: {
                en: "Take vitamin A rich foods like red and yellow fruits (papaya, muskmelon, mango), fortified milk and oils, fish liver oil, peas, ragi etc., as this vitamin may increase iron absorption from food.",
                ar: "",
                hi: "",
              },
              svg: "red-yellow-fruits-and-vegetables.png",
            },
            {
              text: {
                en: "Maintain a healthy weight as any fluctuations from the ideal weight may result in changes in absorption and metabolism of B complex vitamins and thus lead to folate or VitB12 deficiency anemia.",
                ar: "",
                hi: "",
              },
              svg: "healthy-weight-icon-multi-color.png",
            },
            {
              text: {
                en: "If you are a strict vegetarian then you might be vitamin B12 deficient. This vitamin is naturally present in meat, fish, egg and dairy products. You can try cereals fortified with B12, mushrooms and B12 supplements.",
                ar: "",
                hi: "",
              },
              svg: "fish-icon.png",
            },
          ],
        },
      ],
    },
    compact: {
      about: {
        header: {
          en: "About Anemia",
          ar: "حول فقر الدم",
          hi: "एनीमिया के बारे में",
        },
        text: {
          en: "Anemia means there are not enough healthy red blood cells to carry oxygen in your body. Anemia can cause weakness and headache. Women of reproductive age and people with gastrointestinal problems are at higher risk.\n",
          ar: "فقر الدم هو الحالة التي يحتوي فيها جسمك على عدد أقل من كريات الدم الحمراء (خلايا الدم الحمراء) أو أن كريات الدم الحمراء لا تحتوي على ما يكفي من الهيموجلوبين. الهيموجلوبين هو البروتين الموجود في كريات الدم الحمراء التي تساعد في نقل الأكسجين إلى أنسجة الجسم.",
          hi: "एनीमिया वह स्थिति है जहां आपके शरीर में आरबीसी (लाल रक्त कोशिकाएं) कम होती हैं या आरबीसी में पर्याप्त हीमोग्लोबिन नहीं होता है। हीमोग्लोबिन आरबीसी में मौजूद प्रोटीन है जो आपके शरीर के सभी अंगो में ऑक्सीजन ले जाने में मदद करता है।",
        },
      },
      tips: [
        {
          header: { en: "Tips", ar: "نصائح", hi: "टिप्स" },
          tipsArray: [
            {
              text: {
                en: "Eat iron-rich foods like green leafy vegetables, meat, poultry, garden cress seeds, sesame and beans and folate rich foods like kidney beans (rajma), black eyed beans (lobia), chickpeas, brussels sprouts, asparagus and broccoli.",
                ar: " الإكثار من تناول الأطعمة الغنية بالحديد مثل الخضار الورقية والعدس والفول يمنع فقر الدم.",
                hi: "हरी पत्तेदार सब्जियां, दाल और बीन्स जैसे आयरन से भरपूर भोजन खाने से एनीमिया से बचाव होता है।",
              },
              svg: "spinach_colored.svg",
            },
            {
              text: {
                en: "Avoid drinking tea or coffee with your meals, as they can affect iron absorption",
                ar: " تجنب شرب الشاي أو القهوة مع وجباتك، حيث يمكن أن تؤثر على امتصاص الحديد.",
                hi: "अपने खाने के साथ चाय या कॉफी पीने से बचें, क्योंकि वे आयरन  के अवशोषण को प्रभावित कर सकते हैं।",
              },
              svg: "notea.svg",
            },
          ],
        },
      ],
    },
    others: { href: "anemia_studies" },
  },
};

const transformJsonToReducedRows = (json) => {
  const rows = [];

  Object.entries(json).forEach(([profileName, profileData]) => {
    ["advanced", "dynamic", "compact"].forEach((reportType) => {
      const reportData = profileData[reportType];
      if (!reportData) return;

      const about = reportData.about;
      const tipsGroups = reportData.tips || [];

      // Collect all languages
      const langSet = new Set();

      if (about?.header)
        Object.keys(about.header).forEach((lang) => langSet.add(lang));
      if (about?.text)
        Object.keys(about.text).forEach((lang) => langSet.add(lang));

      tipsGroups.forEach((tipsGroup) => {
        if (tipsGroup.header)
          Object.keys(tipsGroup.header).forEach((lang) => langSet.add(lang));
        if (tipsGroup.subHeader)
          Object.keys(tipsGroup.subHeader).forEach((lang) => langSet.add(lang));
        (tipsGroup.tipsArray || []).forEach((tip) => {
          if (tip.text)
            Object.keys(tip.text).forEach((lang) => langSet.add(lang));
        });
      });

      const languages = Array.from(langSet);

      languages.forEach((lang) => {
        const baseRow = {
          "Profile Name": profileName,
          "Report Type": reportType,
          Language: lang,
          About_Header: about?.header?.[lang] || "",
          About_Text: about?.text?.[lang] || "",
        };

        let isFirstTip = true;

        if (tipsGroups.length === 0) {
          // No tips, just push about
          rows.push({
            ...baseRow,
            Tips_Header: "",
            Tips_Subheader: "",
            Tip_Text: "",
            Tip_Icon: "",
          });
        } else {
          tipsGroups.forEach((tipsGroup) => {
            const tipHeader = tipsGroup.header?.[lang] || "";
            const tipSubHeader = tipsGroup.subHeader?.[lang] || "";
            const tipsArray = tipsGroup.tipsArray || [];

            tipsArray.forEach((tip, idx) => {
              rows.push({
                "Profile Name": baseRow["Profile Name"] || "",
                "Report Type": baseRow["Report Type"] || "",
                Language: baseRow["Language"] || "",
                About_Header: isFirstTip ? baseRow["About_Header"] : "",
                About_Text: isFirstTip ? baseRow["About_Text"] : "",
                Tips_Header: tipHeader || "",
                Tips_Subheader: tipSubHeader || "",
                Tip_Text: tip.text?.[lang] || "",
                Tip_Icon: tip.svg || "",
              });
              isFirstTip = false;
            });
          });
        }
      });
    });
  });

  return rows;
};

const handleExport = (contentJson) => {
  if (!contentJson) {
    return;
  }
  const data = transformJsonToReducedRows(contentJson);

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Profile Content");

  XLSX.writeFile(workbook, "profile_content.xlsx");
};

export default handleExport;
